import { ButtonPrimary } from 'app/components/Base/ButtonPrimary'
import {
  applyAllPharmacyDataUpdate,
  applyPharmacyDataUpdate,
} from 'app/services/pharmacyDataUpdate'
import { PropsWithChildren, useState } from 'react'
import { DATASET, Dataset } from '../constants/dataset'

type ApplyPanelProps = {
  description?: string[]
  buttonLabel?: string
  disabled?: boolean
  dataset?: Dataset
  uploadToken?: string
  setJobId: (dataset: Dataset, jobId: string) => void
} & PropsWithChildren

export function ApplyPanel({
  buttonLabel,
  disabled,
  dataset,
  uploadToken,
  setJobId,
  children,
}: ApplyPanelProps) {
  const [isApplying, setIsApplying] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleApply = async () => {
    if (isApplying) {
      return
    }
    setErrorMessage(null)
    setIsApplying(true)
    try {
      if (dataset === undefined) {
        setErrorMessage('データセットが指定されていません')
        setIsApplying(false)
        return
      }
      const response =
        dataset === DATASET.ALL
          ? await applyAllPharmacyDataUpdate()
          : await applyPharmacyDataUpdate(dataset, uploadToken)
      if (!response || typeof response.jobId !== 'string') {
        throw new Error('ジョブIDが取得できませんでした')
      }
      setJobId(dataset, response.jobId)
    } catch {
      setErrorMessage(`マスタ反映に失敗しました`)
    } finally {
      setIsApplying(false)
    }
  }

  return (
    <div className="flex flex-1 flex-col gap-4 justify-between h-full">
      <ButtonPrimary disabled={disabled || isApplying} onClick={handleApply}>
        {isApplying ? '反映中...' : buttonLabel}
      </ButtonPrimary>
      <div className="flex flex-col w-full items-center text-sm text-gray-500">
        {children}
      </div>
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
    </div>
  )
}
